export default __webpack_public_path__ + "static/media/stu.595e79d4.png";